<template>
  <div>
    <!-- Map view button -->
    <!-- <div style="position: absolute; right: 0; margin-top: -45px;">
      <button id="mapTypeButton" @click="mapView()" type="button" class="btn btn-sm btn-primary" disabled>{{ mapViewText }}</button> 
    </div> -->

    <!-- Map-->
    <div id="map2d">
    <gmap-map
        :zoom="7"    
        :center="center"
        style="width:100%;  height: 600px;" id="map-container" v-if="this.showMap"
      ><gmap-marker
        :key="index"
        v-for="(m, index) in locationMarkers"
          :position="m.position"
          :title="m.title"
          :icon="m.icon"
          :clickable="true"
          @click="toggleInfoWindow(m, index)"
      ></gmap-marker>
      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="closeInfoWindow()"
      ><div v-html="infoContent"></div>
      </gmap-info-window>
    </gmap-map>
    </div>

  </div>
</template>
 
<script>
  export default {
    name: "AddGoogleMap",
    data() {
      return {
        ampm: "AM",
        center: { 
            lat: 33.65981766521007, 
            lng: -117.741215116961,
        },
        locationMarkers: [{
          position: {
            lat: 33.65981766521007, 
            lng: -117.741215116961,
          },
          title: "Vitrafy",
          label: "Vitrafy",
          device: "Vitrafy-00004",
          location: "Ballarat (Vitrafy Lab)"
        }],
        locPlaces: [],
        existingPlace: null,
        showMap: true,
        mapViewText: 'Earth',
        location: "not set",
        infoContent: '',
        infoWindowPos: {
            lat: -37.53092219073088,
            lng: 143.84338591371284
        },
        infoWinOpen: false,
        currentMidx: null,
        fullscreenControl:false,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },  
        MarkerOptions:{
          zIndex:999999,
          opacity:0.2

        },
        markers: this.marker,
        fullscreen: false,
        currentTime: '',
        currentDate: '',
        autoRotate: true,
        showClock: false,
      };
    },
    mounted() {

    },
    watch: {

    },
    methods: {
      resetMap() {

      },
      closeInfoWindow() {
        this.location = null;
        this.infoWinOpen = false;

        document.getElementById("marker-data-container").style.display = 'none';

        document.getElementById("device-info-box").style.display = 'none';  
        document.getElementById("tracking-data-loading").style.display = 'none';
        
        document.getElementById("tracking-data-hobart").style.display = 'none';        
        document.getElementById("tracking-data-ballarat").style.display = 'none';
        document.getElementById("tracking-data-other").style.display = 'none';  
      },
      toggleInfoWindow: function (marker, idx) {
        document.getElementById("device-info-box").style.display = 'none';  
        document.getElementById("tracking-data-loading").style.display = 'none';
        
        document.getElementById("tracking-data-hobart").style.display = 'none';        
        document.getElementById("tracking-data-ballarat").style.display = 'none';
        document.getElementById("tracking-data-other").style.display = 'none';  

        this.infoWindowPos = marker.position;
        this.infoContent = this.getInfoWindowContent(marker);

        //check if its the same marker that was selected if yes toggle
        if (this.location == marker.title) {
          this.location = null;
          this.infoWinOpen = !this.infoWinOpen;
          document.getElementById("marker-data-container").style.display = 'none';
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.markerClick(marker.title);
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },
      getInfoWindowContent: function (marker) {
      return (
      `<div class="">
      <div>
        <div>
          <div class="m-2">
            ${marker.location}
          </div>
        </div>
      </div>
      </div>`);
      },
      markerClick(title) {
        // save to local storage
        localStorage.trackingDataTable = title

        document.getElementById("marker-data-container").style.display = 'block';
        console.log("marker clicked " + title);
        this.location = title;

        document.getElementById("device-info-box").style.display = 'none';  
        document.getElementById("tracking-data-loading").style.display = 'none';
        
        document.getElementById("tracking-data-hobart").style.display = 'none';        
        document.getElementById("tracking-data-ballarat").style.display = 'none';
        document.getElementById("tracking-data-other").style.display = 'none';        
        
        setTimeout(function () {
          document.getElementById("device-info-box").style.display = 'block'; 
          document.getElementById("tracking-data-loading").style.display = 'block';
        }, 300);

        if(title == "Hobart") {
          setTimeout(function () {
            document.getElementById("tracking-data-loading").style.display = 'none';
            document.getElementById("tracking-data-hobart").style.display = 'block';
          }, 2000);
        }

        if(title == "Vitrafy") {
          setTimeout(function () {
            document.getElementById("tracking-data-loading").style.display = 'none';
            document.getElementById("tracking-data-ballarat").style.display = 'block';  
          }, 2000);
        }  

        if(title == "Sydney" || title == "Texas") {
          setTimeout(function () {
            document.getElementById("tracking-data-loading").style.display = 'none';
            document.getElementById("tracking-data-other").style.display = 'block';  
          }, 2000);
        }        
      },
      initMarker(loc) {
        this.existingPlace = loc;
      },
      addLocationMarker() {
        if (this.existingPlace) {
          const marker = {
            lat: this.existingPlace.geometry.location.lat(),
            lng: this.existingPlace.geometry.location.lng()
          };
          this.center = marker;
          this.existingPlace = null;
        }
      },
      clearLocation() {
        this.location=null;
      },
      addNewLocationMarker(lat,lng, id) {
          const marker = {
            lat: lat,
            lng: lng
          };
          this.locationMarkers = [];

          //var icon = "https://googlemapsmarkers.s3.ap-southeast-2.amazonaws.com/marker.png";
          var icon = "";

          this.locationMarkers.push({ 
            position: marker, 
            title: id,
            icon: icon
          });
          
          this.center = marker;
      },    
      locateGeoLocation: function() {
        navigator.geolocation.getCurrentPosition(res => {
          this.center = {
            lat: res.coords.latitude,
            lng: res.coords.longitude
          };
        });
      },
      globbeFullScreen: function() {
        // console.log("globbeFullScreen");

        // document.body.appendChild(document.getElementById("globe"));
        // document.getElementById("globe").classList.add("globeFullScreen");

        // document.body.appendChild(document.getElementById("globeBackground"));
        // document.getElementById("globeBackground").classList.add("globeFullScreen");

        // document.body.appendChild(document.getElementById("closeFFullScreen"));
        // document.getElementById("closeFFullScreen").classList.add("closeFFullScreenActive");

        // document.body.appendChild(document.getElementById("toggleOrbit"));
        // document.getElementById("toggleOrbit").classList.add("closeFFullScreenActiveToggle");

        if(this.fullscreen) {
          this.fullscreen = false;
          this.GoOutFullscreen();
        } else {
          this.fullscreen = true;
          this.GoInFullscreen();
        }
      },
      GoInFullscreen: function() {
            var element = document.getElementById("globeContainer");
            
            if(element.requestFullscreen)
                element.requestFullscreen();
            else if(element.mozRequestFullScreen)
                element.mozRequestFullScreen();
            else if(element.webkitRequestFullscreen)
                element.webkitRequestFullscreen();
            else if(element.msRequestFullscreen)
                element.msRequestFullscreen();
      },
      GoOutFullscreen: function() {
            if(document.exitFullscreen)
                document.exitFullscreen();
            else if(document.mozCancelFullScreen)
                document.mozCancelFullScreen();
            else if(document.webkitExitFullscreen)
                document.webkitExitFullscreen();
            else if(document.msExitFullscreen)
                document.msExitFullscreen();
      },
      mapView: function () {
        console.log("map view clicked");
        if(this.showMap) {
          // hide map
          this.showMap = false;
          localStorage.showMap = this.showMap
          this.mapViewText = "Map";

          // show earth
          document.getElementById("earthControls").style.display = 'block';          
          // document.getElementById("toggleOrbit").style.display = 'block';          
          document.getElementById("globeContainer").style.position = 'relative';
          document.getElementById("globeContainer").style.zIndex = '1';
        } else {
          // show map
          this.showMap = true;
          localStorage.showMap = this.showMap
          this.mapViewText = "Earth";

          // hide earth
          // document.getElementById("toggleOrbit").style.display = 'none';
          document.getElementById("earthControls").style.display = 'none';
          document.getElementById("globeContainer").style.position = 'absolute';
          document.getElementById("globeContainer").style.zIndex = '-1';
        }
      },
      async getLocationTest(row) {
          console.log(row);

              var data = {
                "cellTowers": [
                  {
                    "cellId": row.CELLID,
                    "locationAreaCode": row.LAC,
                    "mobileCountryCode": row.MCC,
                    "mobileNetworkCode": row.MNC,
                    "signalStrength": row.RSSI
                  }
                ]
              }

              data = JSON.stringify(data);

              let headers = {
                  'Content-Type': 'application/json;charset=utf-8'
              };   

          try {
              let url = "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyADlrnhMJmtgQZkNOSHUkbguzXVLHGGt6g";

              const response = await this.$http.post(
                  url,
                  data,
                  {headers: headers}
              );

              // show on map (real data) - TEMP DISABLED
              //this.addNewLocationMarker(response.data.location.lat, response.data.location.lng, row.ID + " " + row.formattedTimestamp)   

              // hard coded to office for demo
              // this.addNewLocationMarker(-37.53092219073088, 143.84338591371284, "Vitrafy Life Sciences"); // Vitrafy Office
              // this.addNewLocationMarker(-42.84173646465064, 147.32082174801945, "Hobart"); // Tas (Hobart)

              //this.addLocationMarker(-37.53092219073088, 143.84338591371284); // Vitrafy Office
              //this.addLocationMarker(-42.84173646465064, 147.32082174801945); // Tas (Hobart)

              console.log(response.data);

              document.getElementById("tracking-loading").style.display = 'none';
              document.getElementById("tracking-container").style.display = 'block';

              this.resetMap();

          } catch (error) {
              console.log(error);
          }                                                    
      },
    }
  };
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');

  .settings_input {
    margin-bottom: 5px;
  }

  #earthControls {
    display: none;
  }

  #currentTime {
    margin-top: -10px;
    /* border: 1px solid red; */
    display: inline-block;
    width: 205px;
    text-align: left;
  }

  #ampm {
    display: inline-block;
  }

  #currentDate {
    font-size: 25px;
  }

  #clockContainer {
    /* border: 1px solid red; */
    width: 400px;
    margin: auto;
  }

  #clock {
    position: absolute;
    left: 0px;
    bottom: 10px;
    color: #fff;
    font-size: 40px;
    width: 100%;
    text-align: center;
    font-family: 'Montserrat', sans-serif;
  }

  #vitrafyEarth-logo {
    position: absolute;
    top: 9px;
    left: 11px;
    height: 33px;
  }

  #globeContainer {
    position: absolute;
  }

  #map2d {
    height: 100%;
    width: 100%;
    top: 0;
  }

  .globeFullScreen {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
  }

  .closeFFullScreenActive {
    display: block !important;
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 99999;
  }

  #toggleOrbit {
    /* display: none; */
    cursor: pointer;
    position: absolute;
    /* top: 5px; */
    left: 11px;
    z-index: 99999;
  }

  #showClock {
    cursor: pointer;
  }

  .closeFFullScreenActiveToggle {
    display: block !important;
    position: absolute !important;
    top: 20px !important;
    left: 20px !important;
    z-index: 99999 !important;
  }  

  .blackBackground {
    background: #000;
  }

  .displayNone {
    display: none !important;
  }

  #marker-data-container-container{
    background-color: #fff;
    min-height: 500px;
  }
</style>
